import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import {
  ForumEditorToolbarOption,
  ForumEditorToolbarOptionType,
} from "./forum-editor-toolbar.types";

@Component({
  selector: "forum-editor-toolbar",
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: "./forum-editor-toolbar.component.html",
  styleUrls: ["./forum-editor-toolbar.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForumEditorToolbarComponent {
  @Input() options: ForumEditorToolbarOption[] = [];

  readonly optionType = ForumEditorToolbarOptionType;

  handleActionClick(
    event: MouseEvent,
    option: ForumEditorToolbarOption,
  ): void {
    event.preventDefault();
    event.stopPropagation();

    if (option.type !== ForumEditorToolbarOptionType.Action) {
      return;
    }

    option.actionFn();
  }
}
